<div *ngIf="contextualHelpValue" class="help-content">
  <div class="contextual-help-header">
    <h5
      class="title vo-heading-regular-16 m-0"
      [innerHtml]="referenceDataLabels.ContextualHelpBoxTitle | localizeLabel"
    ></h5>

    <div class="d-md-none vo-icon vo-icon-x vo-icon--16 cursor-pointer" (click)="closeContextualHelp()"></div>
    <div
      class="d-none d-md-block fs-14"
      *ngIf="contextualHelpContent.offsetHeight < contextualHelpContent.scrollHeight || showMoreContent"
    >
      <span
        class="show-more-link vo-link cursor-pointer"
        *ngIf="!showMoreContent; else showLessLink"
        (click)="showMore()"
        [innerHtml]="referenceDataLabels.ContextualHelpBoxShowMore | localizeLabel"
      ></span>
      <ng-template #showLessLink>
        <span
          class="show-less-link vo-link cursor-pointer"
          (click)="showLess()"
          [innerHtml]="referenceDataLabels.ContextualHelpBoxShowLess | localizeLabel"
        ></span>
      </ng-template>
    </div>
  </div>
  <div
    #contextualHelpContent
    class="contextual-help-content vo-body-regular-14"
    [ngClass]="{ 'less-content': !showMoreContent, 'more-content': showMoreContent }"
    [innerHTML]="contextualHelpValue ? contextualHelpValue : ''"
  ></div>

  <div
    class="d-md-none mt-10 fs-14"
    *ngIf="contextualHelpContent.offsetHeight < contextualHelpContent.scrollHeight || showMoreContent"
  >
    <span
      class="show-more-link vo-link cursor-pointer"
      *ngIf="!showMoreContent; else showLessLink"
      (click)="showMore()"
      [innerHtml]="referenceDataLabels.ContextualHelpBoxShowMore | localizeLabel"
    ></span>
    <ng-template #showLessLink>
      <span
        class="show-less-link vo-link cursor-pointer"
        (click)="showLess()"
        [innerHtml]="referenceDataLabels.ContextualHelpBoxShowLess | localizeLabel"
      ></span>
    </ng-template>
  </div>
</div>
